<template>
    <section class="mbs-wrap mbs016" :style="dBHeight">
        <!-- <modals-container></modals-container> -->
        <section class="mbs-header">
            <div class="inner">
                <div class="tit-box">
                    <h3>{{ $i18nUtil.trans("title.ModifyNotiSetting.001","알림 설정") }}</h3>
                </div>
            </div>
        </section>
        <div class="pw-box">
            <ul class="list-table">
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ModifyNotiSetting.000","알림 방법 설정") }}</dt>
                        <dd>
                            <ul class="list_dot" v-if="tenantId == '201'">
                                <li v-html="$i18nUtil.trans('message.ModifyNotiSetting.001','알림을 보낼 채널을 설정합니다.')"></li>
                            </ul>
                            <ul class="list_dot" v-else>
                                <li v-html="$i18nUtil.trans('message.ModifyNotiSetting.001','알림을 보낼 채널을 설정합니다. <br>이메일 또는 푸시 알림 둘 중 한가지는 필수로 ON상태여야 합니다.')"></li>
                                <li>{{$i18nUtil.trans("message.ModifyNotiSetting.002","설정한 채널로 할 일, 의사결정 , 호출 모두 발송됩니다.")}}</li>
                            </ul>
                            <div>
                                <label class="switch">
                                    <input type="checkbox" v-model="emailNoti" @change="fEmailNoti">
                                    <span class="slider"></span>
                                    {{ $i18nUtil.trans("message.ModifyNotiSetting.009","이메일") }}
                                </label> 
                            </div>
                            <div v-if="tenantId != '201'">
                                <label class="switch" >
                                    <input type="checkbox" v-model="appPush" @change="fAppPush">
                                    <span class="slider"></span>
                                    {{ $i18nUtil.trans("message.ModifyNotiSetting.010","앱 푸시") }}
                                </label> 
                            </div>
                        </dd>
                    </dl>
                </li>
            </ul>
        </div>
        <modals-container/>
    </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    components: {
    },
    data() {
        return {
            /* tenantId */
            tenantId: localStorage.getItem("tenantId"),
            dBHeight: {
                'min-height': (window.innerHeight - 153) + 'px',
            },
            emailNoti:true,
            appPush:true,
            notiSettingId :null,

            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000
                }
            },
        }
    }, 
    mounted() { 
        this.getNotiSettings();

        // 뒤로가기 이벤트 발생시 .
        const self = this;
        window.onpopstate = function (event) {
            let returnUrls = localStorage.getItem("returnUrls");
            if(returnUrls != null) {
                let urlList = returnUrls.split(",");
                if (urlList.length > 0) {
                    if (urlList.length == 1) {
                        localStorage.removeItem("returnUrls");
                        // self.$router.push("/general/home");
                    } else {
                        urlList.pop();
                        urlList.pop();
                        localStorage.setItem("returnUrls", urlList);
                        // this.$router.replace(urlList[urlList.length-1]);
                    }
                } else {
                    self.$router.push("/general/home");
                }
            }else{
                self.$router.push("/general/home");
            }
        }
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showModal", "showToast"]),
        getNotiSettings(){ 
            let obj = this;
            let reqData = {};
            reqData.params ={ };
            reqData.req = obj.req;
            reqData.url = "/api/noti/getNotiSettings";
            reqData.method = "post";
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {
                    this.notiSettingId=res.result.notiSettings.notiSettingId;
                
                    this.emailNoti=res.result.notiSettings.notiEmailYn === 1 ? true : false;
                    this.appPush=res.result.notiSettings.notiAppPushYn === 1 ? true : false;
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
        updateNotiSetting(){ 
            let obj = this;
            let reqData = {};
            reqData.params ={
                appPush : this.appPush ? "1" : "0",
                emailNoti : this.emailNoti ? "1" : "0",
                notiSettingId : this.notiSettingId, 
            }
 
            reqData.req = obj.req;
            reqData.url = "/api/noti/updateNotiSettings";
            reqData.method = "post";
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {})
                .catch(function(err) { console.log(err); });
        }, 
        fEmailNoti(){
            if(!this.appPush && !this.emailNoti){
                this.showAlertDialog(this.$i18nUtil.trans("message.ModifyNotiSetting.003","모두 OFF할 수 없습니다. 하나의 채널은 필수로 ON 해주세요."), null, {width: "400px"});
                this.$nextTick(function(){
                    this.emailNoti = true;  
                }) 
            }else { 
                if(this.emailNoti){
                    this.toastInfo.message = this.$i18nUtil.trans("message.ModifyNotiSetting.004","이메일 알림이 설정되었습니다. 이제 알림을 받아보실 수 있습니다.");
                    this.showToast(this.toastInfo);
                }else{
                    this.toastInfo.message = this.$i18nUtil.trans("message.ModifyNotiSetting.005","이메일 알림이 해제되었습니다. 알림 수신을 원하시면 활성화 해주세요.");
                    this.showToast(this.toastInfo);
                }
                this.updateNotiSetting();
            }
        },
        fAppPush(){
            if(!this.appPush && !this.emailNoti){
                this.showAlertDialog(this.$i18nUtil.trans("message.ModifyNotiSetting.006","모두 OFF할 수 없습니다. 하나의 채널은 필수로 ON 해주세요."), null, {width: "400px"});
                this.$nextTick(function(){
                    this.appPush = true;   
                }) 
            }else {
                if(this.appPush){
                    this.toastInfo.message = this.$i18nUtil.trans("message.ModifyNotiSetting.007","앱 푸시 알림이 설정되었습니다. 이제 알림을 받아보실 수 있습니다.");
                    this.showToast(this.toastInfo);
                }else{
                    this.toastInfo.message = this.$i18nUtil.trans("message.ModifyNotiSetting.008","앱 푸시 알림이 해제되었습니다. 알림 수신을 원하시면 활성화 해주세요.");
                    this.showToast(this.toastInfo);
                }
                this.updateNotiSetting();
            }
        },
    }
};
</script>

<style scoped>
.disabled{
    pointer-events:none;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/ModifyNotiSetting.vue